import React, { useEffect, useState, useContext } from 'react';
import { Table, Select, Spin, Modal, Button } from 'antd';
import { LoadingOutlined, CheckOutlined, CloseOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex'
import uuidv4 from 'uuid/v4';
import {
  dateToString,
  stringToDate,
  MULTI_DATE_FORMATS,
} from '../../../utils/dateUtils';
import { ModelContext } from '../../metadata/ModelSource';
import { Tooltip } from 'antd';
import {DatePicker} from '../../fields/DatePicker';

const { Option } = Select;

const InfractionsTable = ({ driverInfractionCds, formContext }) => {
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [editedOccurrenceDate, setEditedOccurrenceDate] = useState();
  const [editedInfraction, setEditedInfraction] = useState('');
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const applicationModel = useContext(ModelContext);
  const { prefix } = formContext;
  const prefixPath = `${prefix}driverInfo.driverPoints`;
  let container = applicationModel.getValue(prefixPath);


  useEffect(() => {
    if (container === undefined) {
      container = [];
      applicationModel.setValue(prefixPath, container);
    }
    let activeDriverPoints = container.length > 0 ? container.filter((driverPoint) => driverPoint.status === 'Active') : [];
    if(activeDriverPoints.length){    //if there are driverPoints on container add them to the form otherwise add an empty driver point to form
      const newData = [...data];
      activeDriverPoints.forEach(driverPoint => {
        const {infractionCd} = driverPoint;
        const infractionDesc = getInfractionDescription(infractionCd);
        newData.push({...driverPoint, infractionCd: infractionDesc});
      });
      setData(newData);
    }else{
      addInfraction()
    }
  }, []);

  const addInfraction = () => {
    const tempId = uuidv4();

    const newData = [...data];

        newData.push({
        infractionDt: (
            <DatePicker aria-label="Select infraction date" onChange={handleDateSelect}/>
        ),
        infractionCd: <InfractionSelect aria-label="Select infraction"/>,
        id: tempId,
      });
    setData(newData);
    setEditingKey(tempId);
    setDisabled(true);

  };

  const editInfraction = (record) => {
    let container = applicationModel.getValue(prefixPath);
    const formItem = find(container,{id: record.id});
    const newData = [...data];

    const editableData = {
      ...record,
      infractionDt: (
        <DatePicker
          aria-label="Select infraction date"
          defaultValue={stringToDate(formItem.infractionDt)}
          onChange={handleDateSelect}
        />
      ),
      infractionCd: <InfractionSelect aria-label="Select infraction" previousValue={formItem.infractionCd} />,
    };

    setEditingKey(record.id);
    setDisabled(true);

    const index = findIndex(newData,{id: record.id});
    if (index > -1) {
      const item = newData[index];
      newData.splice(index, 1, {
        ...item,
        ...editableData,
      });
      setData(newData);
    }
  };

  const saveInfraction = (record) => {
    setLoading(true);
    setDisabled(true);
    const newData = [...data];
    let container = applicationModel.getValue(prefixPath);
    const dataIndex = findIndex(newData,{id: record.id});
    const item = newData[dataIndex];
    const containerIndex = findIndex(container,{id: record.id});
    const updatedInfraction = find(driverInfractionCds, {
      infractionCd: editedInfraction,
    });

    let formItem;
    if(containerIndex > -1) {
      formItem = container[containerIndex];
      container.splice(containerIndex, 1, {
        ...formItem,
        ...record,
        infractionDt:
             editedOccurrenceDate !== undefined
                ? editedOccurrenceDate
                : formItem.infractionDt,
        infractionCd:
            updatedInfraction !== undefined
                ? updatedInfraction.infractionCd
                : formItem.infractionCd,
        pointsCharged:  updatedInfraction !== undefined ? updatedInfraction.points : formItem.pointsCharged,
        status: 'Active',
      });
    }else{
      container.push({
        ...formItem,
        ...record,
        infractionDt: editedOccurrenceDate,
        infractionCd: updatedInfraction.infractionCd,
        pointsCharged:  updatedInfraction !== undefined ? updatedInfraction.points : formItem.pointsCharged,
        status: 'Active',
      });
    }

    newData.splice(dataIndex, 1, {
      ...item,
      ...record,
      infractionDt:
          editedOccurrenceDate !== '' && editedOccurrenceDate !== undefined
              ? editedOccurrenceDate
              : formItem.infractionDt,
      infractionCd:
          updatedInfraction !== undefined
              ? updatedInfraction.description
              : getInfractionDescription(formItem.infractionCd),
      pointsCharged:  updatedInfraction !== undefined ? updatedInfraction.points : formItem.pointsCharged,
      status: 'Active',
    });


      setLoading(false);
      setDisabled(false);
      setData(newData);
      setEditingKey('');
      //applicationModel.modification();
      setEditedOccurrenceDate(undefined);
      setEditedInfraction('');

 };

  const deleteInfraction = () => {
    //if the infraction is saved, it means it's on the container, set status to deleted on the container and delete it from the form
    //otherwise infraction hasn't been saved just delete it from the form

    const newData = [...data];
    let container = applicationModel.getValue(prefixPath);
    const containerIndex = findIndex(container,{id: editingKey});
    const formIndex = findIndex(newData,{id: editingKey});
    setLoading(true);

    if(containerIndex > -1) { //if infraction is saved already which means it's on the container, set status to delete on the container and delete it from newData
      container.splice(containerIndex, 1, {
        ...container[containerIndex],
        status: 'Deleted',
      });
    }

      newData.splice(formIndex,1);

      setTimeout(() => {
      setLoading(false);
      setData(newData);
      setModalVisible(false);
      //applicationModel.modification();
    }, 1000);
  };

  const cancelEdit = (record) => {
    //if canceling edit to an item that has not been saved to container yet just remove it from newData
    //if canceling edit to  an item in the container restore the text fields
    const newData = [...data];
    const containerItem = find(container,{id:record.id});

    if(containerItem === undefined){
      //canceling edit to an item that has not been saved to container yet just remove it from newData
      const itemIndex = findIndex(newData,{id:record.id});
      newData.splice(itemIndex, 1);
    }else{
      //if canceling edit to an item in the container restore the text fields
      const itemIndex = findIndex(newData,{id:record.id});
      newData.splice(itemIndex,1,{
        ...newData[itemIndex],
        infractionCd: getInfractionDescription(containerItem.infractionCd),
        infractionDt: containerItem.infractionDt
      })
    }
    setData(newData);
    setDisabled(false);
    setEditedInfraction('');
    setEditedOccurrenceDate(undefined);
    setEditingKey('');
  };

  const antIcon = <LoadingOutlined style={{ fontSize: '18px' }} spin />;

  const columns = [
    {
      title: 'Occurrence Date',
      dataIndex: 'infractionDt',
      key: 'infractionDt',
      width: 200,
    },
    {
      title: 'Infraction',
      dataIndex: 'infractionCd',
      key: 'infractionCd',
      width: 300,
    },
    {
      title: '',
      dataIndex: 'operation',
      width: 200,
      align: 'right',
      render: (text, record) => {
        if (record.id === editingKey) {     //icons for current record being edited
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignContent: 'center',
                width: '80px',
                marginRight: 'auto',
                paddingTop: '4px',
              }}
            >
              {loading ? (
                <Spin indicator={antIcon} />
              ) : (
                <Tooltip title={'Save'}>
                  <Button icon={<CheckOutlined />}
                        type={'primary'}
                        className={'save-infraction-btn'}
                        onClick={() => saveInfraction(record)}
                        disabled={disableSaveButton(record)}
                />
                </Tooltip>
              )}
              <Tooltip title={'Cancel Edit'}>
                <Button className={'cancel-edit-infraction-btn'}
                        onClick={() => cancelEdit(record)}
                        icon={<CloseOutlined />}
                        type={'secondary'}
                />
              </Tooltip>
              </div>
          );
        }
        return (
          //icons for all other records
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '80px',
            }}
          >
            <Tooltip title='Edit'>
              <Button disabled={disabled}
                    className={'edit-infraction-btn'}
                    onClick={() => editInfraction(record)}
                    icon={<EditOutlined />}
                    type={'primary'}
              />
          </Tooltip>
            <Tooltip title='Delete'>
            <Button
                className={'delete-infraction-btn'}
                disabled={disabled}
                onClick={() => {
                  setModalVisible(true);
                  setEditingKey(record.id);
                }}
                icon={<DeleteOutlined />}
                type={'secondary'}
            />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const handleDateSelect = (value) => {
    setEditedOccurrenceDate(value ? value : null);
  };

  const handleSelect = (value) => {
    setEditedInfraction(value);
  };

  const  getInfractionDescription = (infractionCd) => {
    return driverInfractionCds.find((el) => infractionCd === el.infractionCd).description;
  }

  const disableSaveButton = (record) =>{
    //if infractionDt or infractionCd can not be derived from the container element or the form disable the save button
    let [invalidInfractDt, invalidInfract] = [true,true];
    let container = applicationModel.getValue(prefixPath);
    let containerItem = find(container,{id:record.id});

    if(containerItem || editedOccurrenceDate !== undefined){
      invalidInfractDt = false;
    }

    if(containerItem || editedInfraction !== '') {
      invalidInfract = false;
    }
    return invalidInfractDt || invalidInfract;
  }

  const InfractionSelect = ({ previousValue, loading }) => (
    <Select
      className={'infraction-select'}
      defaultValue={previousValue ? previousValue : ''}
      onChange={handleSelect}
      style={{ width: '200px' }}
      loading={loading}
      showSearch
      filterOption={(input, option) =>
        option.props.children.toLowerCase().startsWith(input.toLowerCase())
      }
    >
      {driverInfractionCds &&
        driverInfractionCds.map((infraction, index) => (
          <Option key={index} value={infraction.infractionCd} label={infraction.description}>
            {infraction.description}
          </Option>
        ))}
    </Select>
  );

  return (
    <div>
      <Modal
        title="Infraction"
        visible={modalVisible}
        onCancel={() => {setModalVisible(false); setEditingKey('')}}
        footer={[
          <button
            className="cancel-button"
            key="back"
            onClick={() => {setModalVisible(false); setEditingKey('')}}
          >
            Cancel
          </button>,
          <Button
            loading={loading}
            key="submit"
            type="primary"
            onClick={() => {
              deleteInfraction();
            }}
          >
            Remove
          </Button>,
        ]}
      >
        <p>Are you sure you want to remove this infraction?</p>
      </Modal>
      <Table
        bordered={false}
        pagination={false}
        dataSource={data}
        columns={columns}
        rowKey={'id'}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '10px',
        }}
      >
        <Button className={'add-more-infractions'} type="default" disabled={disabled} onClick={() => addInfraction()}>
          Add More Infractions
        </Button>
      </div>
    </div>
  );
};
export default InfractionsTable;
